import React, { ReactElement } from 'react';
import dynamic from 'next/dynamic';
import classNames from 'classnames/bind';
import RootLayout from 'layouts/RootLayout';
import styles from 'pages/events/global-freight-summit/GlobalFreightSummit.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = dynamic(() => import('sections/Events/GlobalFreightSummit/components/SectionHeader'));
const SectionDescription = dynamic(() => import('sections/Events/GlobalFreightSummit/components/SectionDescription'));
const SectionVideo = dynamic(() => import('sections/Events/GlobalFreightSummit/components/SectionVideo'));
const SectionFeatures = dynamic(() => import('sections/Events/GlobalFreightSummit/components/SectionFeatures'));

export default function GlobalFreightSummit() {
  return (
    <div className={cn('global-freight-summit')}>
      <SectionHeader/>
      <SectionDescription/>
      <SectionVideo/>
      <SectionFeatures/>
    </div>
  );
}

export const getStaticProps = async () => {
  return {
    props: {
      title: 'Global Freight Summit Information | DF Alliance',
      description:
        'Attend DF Alliance\'s Global Freight Summit to network with industry professionals and gain insights into the future of global logistics and supply chain solutions.',
      path: '/events/global-freight-summit',
    },
  };
};

GlobalFreightSummit.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
